import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const OWNER_FLAT_NUMBER_NAME = 'owner.flat_number';

const InputFlatNumber = ({
  name = OWNER_FLAT_NUMBER_NAME,
  focused,
  setFocused,
  disabled,
}: {
  name: string;
  focused: string;
  setFocused: (value: string) => void;
  disabled?: boolean;
}) => {
  const { i18n } = useLingui();
  const { trigger } = useFormContext();

  return (
    <FormField
      name={name}
      render={({ field, fieldState }) => {
        const { onChange, onBlur, ...restField } = field;

        return (
          <FormItem className="col-span-2">
            <FormControl>
              <Input
                label={i18n.t('Nr lokalu')}
                disabled={disabled}
                error={
                  !disabled && fieldState.error?.message
                    ? fieldState.error?.message
                    : undefined
                }
                success={
                  focused !== field.name && !fieldState.error && field.value
                }
                onChange={(e) => {
                  onChange(e);
                  if (fieldState.error) {
                    trigger(field.name);
                  }
                }}
                onBlur={() => {
                  setFocused('');
                  onBlur();
                }}
                onFocus={() => setFocused(field.name)}
                {...restField}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default InputFlatNumber;
